import React from 'react';
export function PaymentRequestsShimmer() {
  return <div className="space-y-6 animate-pulse" role="status" aria-busy="true" aria-live="polite" data-id="element-15403" data-mp="ezj8hyktbn2f">
      <span className="sr-only" data-id="element-15404" data-mp="10xbi136fbwrh">Loading payment requests…</span>
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-15405" data-mp="10v8fjjo34b5v">
        <div className="h-6 w-56 bg-gray-200 rounded" data-id="element-15406" data-mp="vzt38w5q6nbk" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15407" data-mp="1tlyuc9973bsw" />
      </div>
      {/* Tabs */}
      <div className="border-b border-gray-200 pb-0" data-id="element-15408" data-mp="1on5s5czcz781">
        <div className="flex gap-8" data-id="element-15409" data-mp="1onp0c1z7ih8v">
          {[1, 2, 3, 4, 5].map(i => <div key={i} className="pb-4" data-id="element-15410" data-mp="1jn1bnmygacht">
              <div className="h-4 w-24 bg-gray-200 rounded" data-id="element-15411" data-mp="1jq5lp0ylk2ge" />
            </div>)}
        </div>
      </div>
      {/* Form Content */}
      <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-15412" data-mp="895w4d3mw1q2">
        <div className="space-y-6" data-id="element-15413" data-mp="39sxkv3eh67n">
          {/* Amount section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15414" data-mp="38hw51xfgajp">
            <div data-id="element-15415" data-mp="33uqambr7hlc8">
              <div className="h-4 w-20 bg-gray-200 rounded mb-2" data-id="element-15416" data-mp="33u86yu27s4ua" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15417" data-mp="38t1l8opbrzvi" />
            </div>
            <div data-id="element-15418" data-mp="2tvra5gglgw0b">
              <div className="h-4 w-24 bg-gray-200 rounded mb-2" data-id="element-15419" data-mp="2twaic5gg0615" />
              <div className="h-12 w-full bg-gray-200 rounded-md" data-id="element-15420" data-mp="2yulredywycib" />
            </div>
          </div>
          {/* Description */}
          <div data-id="element-15421" data-mp="2l2xg2cwhns2e">
            <div className="h-4 w-28 bg-gray-200 rounded mb-2" data-id="element-15422" data-mp="2l2fd6xfbmfli" />
            <div className="h-24 w-full bg-gray-200 rounded-md" data-id="element-15423" data-mp="2ptnq43fv0j3f" />
          </div>
          {/* Additional fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-15424" data-mp="2b5sv2gedq2n6">
            {[1, 2, 3, 4].map(i => <div key={i} data-id="element-15425" data-mp="2g55qhpjbgi1d">
                <div className="h-4 w-32 bg-gray-200 rounded mb-2" data-id="element-15426" data-mp="2g4dtqbdzge9i" />
                <div className="h-10 w-full bg-gray-200 rounded-md" data-id="element-15427" data-mp="225e6n864c7fg" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Action bar */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 flex justify-between items-center" data-id="element-15428" data-mp="cmxspqj24erg">
        <div className="h-4 w-96 bg-gray-200 rounded" data-id="element-15429" data-mp="7vz9ai2rv0jz" />
        <div className="h-10 w-40 bg-gray-200 rounded-md" data-id="element-15430" data-mp="7v67lvio718p" />
      </div>
    </div>;
}